




























































































































































































































































































































































































    import { Component, Vue } from 'vue-property-decorator'
    import Bubbles from "@/components/Bubbles.vue"

    @Component({
        components: {
            Bubbles
        }
    })


	export default class BubblePage extends Vue {
		data() {
			return {
				PageTitle: "Bubbles Transition Page"
			}
        }
    }
